import { type EffectCallback, useEffect, useRef } from 'react';

/**
 * Hook that runs an effect only once, similar to componentDidMount
 * @param effect The effect function to run once
 */
export const useEffectOnce = (effect: EffectCallback): void => {
  const effectRef = useRef<EffectCallback>(effect);
  const executedRef = useRef<boolean>(false);

  useEffect(() => {
    if (executedRef.current) {
      return;
    }

    executedRef.current = true;
    return effectRef.current();
  }, []);
};

export default useEffectOnce;
